/**
 * @fileoverview Collapsible - Expandable/collapsible content container
 *
 * Purpose: Hide and show content with a toggle trigger
 * Dependencies: Radix UI Collapsible primitives
 * Used by: Sidebar menus, expandable sections, settings panels
 *
 * Components exported:
 * - Collapsible: Root container
 * - CollapsibleTrigger: Button/element that toggles visibility
 * - CollapsibleContent: Content that expands/collapses
 *
 * Features:
 * - Smooth expand/collapse animations
 * - Controlled or uncontrolled state
 * - Keyboard accessible
 * - Flexible trigger element
 *
 * @example
 * <Collapsible>
 *   <CollapsibleTrigger asChild>
 *     <Button variant="ghost">Toggle Content</Button>
 *   </CollapsibleTrigger>
 *   <CollapsibleContent>
 *     <p>This content can be collapsed</p>
 *   </CollapsibleContent>
 * </Collapsible>
 *
 * @example
 * // Controlled state
 * const [isOpen, setIsOpen] = useState(false);
 * <Collapsible open={isOpen} onOpenChange={setIsOpen}>
 *   <CollapsibleTrigger>
 *     {isOpen ? "Hide" : "Show"} Details
 *   </CollapsibleTrigger>
 *   <CollapsibleContent>Details here...</CollapsibleContent>
 * </Collapsible>
 */

"use client";

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
